import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import "./Profile.css"
import { ClosePopup, DeactivateAccountPopup, MenuDropdown, TabSwitch, UploadInput } from "../common/Common";
import { LocaleContext, LoginContext, NavigateLockContext, OverlayContext, StateContext } from "../common/App";
import { compareMediationStatus, resetLoginStatesConsumer, uploadFile, uploadFiles } from "../common/util";
import { resolvePath, useSearchParams } from "react-router-dom";
import { MediationStatus, UserType } from "../common/enums.mjs";
import { Documents } from "../common/Documents";
import { ProfileData } from "../common/ProfileData";
import { Wishes } from "../common/Wishes";
import { Invoices } from "./Invoices";
import { ConsumerContext } from "..";
import { useNavigateSmart } from "../common/hooks";

export function Profile(props) {
    // VARS:

    const [searchParams, setSearchParams] = useSearchParams();  
  
    // Get the value of the query parameter you're interested in  
    const tab = searchParams.get("tab");

    const locale = useContext(LocaleContext);
    const state = useContext(StateContext);
    const login = useContext(LoginContext);
    const consumer = useContext(ConsumerContext);
    const navigateLock = useContext(NavigateLockContext);

    const navigate = useNavigateSmart();

    const menuBtnRef = useRef();

    const [menuDisplayed, setMenuDisplayed] = useState(false);
    const [tabIdx, setTabIdx] = useState(tab === "invoices" ? 2 : 0);


    // FUNCTIONS:

    function handleDeleteAccount() {
        consumer.setDeleteAccountDisplayed(true);
    }
    

    // RENDER:

    return (
        <div className="profile tab_switch_ext_bottom_paading">
            <div className="profile_box_top">
                <div className="head profile_head">{locale.msgs.MY_PROFILE}</div>
                <div className="text_2 margin_top_low_low">{locale.msgs.MY_PROFILE_DESCR}</div>

                <div ref={menuBtnRef} className="profile_menu_btn_box"
                        onClick={(e) => navigateLock.handleLockProtectedClick(e, (e) => setMenuDisplayed(!menuDisplayed))}>
                    <img className="profile_menu_btn_img" src="/common/icon_menu_2.svg"></img>
                </div>

                <div className="profile_menu_box">
                    <MenuDropdown menuBtnRef={menuBtnRef} menuDisplayed={menuDisplayed} setMenuDisplayed={setMenuDisplayed}
                            handleDeleteAccount={handleDeleteAccount}
                            elements={[
                                <div className="menu_dropdown_item noselect" onClick={handleDeleteAccount}>
                                    <img src="/common/icon_delete.svg"></img>
                                    <div className="text_light_2 menu_dropdown_item_text">{locale.msgs.DELETE_ACCOUNT}</div>
                                </div>
                            ]}/>
                </div>

                <div className="popup_box">
                    {/*
                    <DeleteAccountPopup confirmDisplayed={confirmDisplayed} setConfirmDisplayed={setConfirmDisplayed}
                            onAccountDeleted={() => {
                                resetLoginStatesConsumer(login, consumer);
                            }}
                    />
                    */}
                    
                </div>
            </div>
            
            <TabSwitch resizing={props.loading} setTabIdx={(idx) => setTabIdx(idx)} currentTabIdx={tabIdx}
                    tabNames={
                        login.userType == UserType.NANNY ?
                            [locale.msgs.DOCUMENTS, locale.msgs.DATA, locale.msgs.WISHES_NANNY]
                        :
                            [locale.msgs.DATA, locale.msgs.WISHES_FAMILY, locale.msgs.INVOICES]
                    }
                    tabElements={
                        login.userType == UserType.NANNY ?
                            [
                                <div className="profile_documents_box tab_switch_paading">
                                    <Documents readOnly={compareMediationStatus(consumer.mediationStatus, MediationStatus.MATCH_FOUND)}
                                            lockNavigation={true} />
                                </div>,
                                <ProfileData userDataOrig={props.userData} userType={login.userType} readOnly={true}
                                        email={login.username} setEmail={(email) => {/* Customer can not change email */}}
                                        displayLanguage={consumer.displayLanguage} setDisplayLanguage={(lang) => {/* Customer can not change display language */}}
                                        location={consumer.userLocation}
                                        mediationStatus={consumer.mediationStatus}
                                        newsletter={consumer.newsletter}
                                        management={false}
                                />,
                                <Wishes userDataOrig={props.userData} userType={login.userType} readOnly={true}/>
                            ]
                        :
                            [
                                <ProfileData userDataOrig={props.userData} userType={login.userType} readOnly={true}
                                        email={login.username} setEmail={(email) => {/* Customer can not change email */}}
                                        displayLanguage={consumer.displayLanguage} setDisplayLanguage={(lang) => {/* Customer can not change display language */}}
                                        location={consumer.userLocation}
                                        mediationStatus={consumer.mediationStatus}
                                        newsletter={consumer.newsletter}
                                        management={false}
                                />,
                                <Wishes userDataOrig={props.userData} userType={login.userType} readOnly={true}/>,
                                <Invoices />
                            ]
                    }
            />
        </div>
    );
}
